import types from './types';

const initialState = {
  availableDomains: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_AVAILABLE_DOMAINS_SUCCESS:
      return {
        ...state,
        availableDomains: action.payload.available_domains,
      };

    default:
      return state;
  }
};
